/** @format */

import { useState, useEffect } from "react";
import SideBar from "./SideBar";
import { hamburguerIcon } from "../../assets/icons";


// Why menu wrapper??
// I thought about adding a minimal menu when closed, but i'm having doubts
// This also works if you want multiple sections in the menu

export default function MenuWrapper() {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section className="absolute top-0">
      <button
        className="absolute top-0 mt-6 ml-4 bg-white rounded-lg hover:bg-white_hover p-3 text-secondary_accent_hover z-30"
        onClick={toggleMenu}
      >
        {hamburguerIcon}
      </button>
      {
        <div className={`z-30 fixed w-full sm:w-96 top-0 left-0 h-full transition duration-300 transform ${!isOpen ? "-translate-x-full" : ""}`}>
          <SideBar closeMenu={() => setIsOpen()}/>
        </div>
      }
    </section>
  );
}
